import React, { useState, useEffect, useCallback, useRef } from 'react';
import api from '../../services/api';

const BACKEND_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3001/api').replace(/\/api$/, '');

export default function AbaFotos({ produtoId }) {
  const [fotos, setFotos]       = useState([]);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro]         = useState('');
  const inputRef = useRef(null);

  const carregar = useCallback(async () => {
    if (!produtoId) { setFotos([]); return; }
    try {
      const { data } = await api.get(`/produtos/${produtoId}/fotos`);
      setFotos(data);
    } catch { setFotos([]); }
  }, [produtoId]);

  useEffect(() => { carregar(); }, [carregar]);

  const enviar = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setEnviando(true); setErro('');
    try {
      for (const file of files) {
        const fd = new FormData();
        fd.append('foto', file);
        await api.post(`/produtos/${produtoId}/fotos`, fd,
          { headers: { 'Content-Type': 'multipart/form-data' } });
      }
      await carregar();
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao enviar a imagem.');
    } finally {
      setEnviando(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  const marcarPadrao = async (foto) => {
    try {
      await api.patch(`/produtos/${produtoId}/fotos/${foto.id}/padrao`);
      await carregar();
    } catch (err) { setErro(err.response?.data?.erro || 'Erro ao definir foto padrão.'); }
  };

  const excluir = async (foto) => {
    if (!window.confirm('Excluir esta foto?')) return;
    try {
      await api.delete(`/produtos/${produtoId}/fotos/${foto.id}`);
      await carregar();
    } catch (err) { setErro(err.response?.data?.erro || 'Erro ao excluir a foto.'); }
  };

  if (!produtoId) {
    return (
      <div style={{ padding: 24, color: '#888', fontSize: 13, fontStyle: 'italic' }}>
        Salve o produto antes de adicionar fotos.
      </div>
    );
  }

  return (
    <div style={{ padding: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
        <button
          style={{ padding: '6px 14px', fontSize: 13, cursor: 'pointer' }}
          disabled={enviando}
          onClick={() => inputRef.current?.click()}>
          {enviando ? 'Enviando…' : '📷 Adicionar fotos'}
        </button>
        <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/gif,image/webp"
          multiple style={{ display: 'none' }} onChange={enviar} />
        <span style={{ fontSize: 11, color: '#777' }}>
          JPG, PNG, GIF ou WebP até 5 MB. A primeira foto vira a padrão; use a ⭐ para trocar.
        </span>
      </div>

      {erro && (
        <div style={{ background: '#fef2f2', border: '1px solid #ef4444', borderRadius: 4,
          padding: '6px 10px', fontSize: 12, color: '#b91c1c', marginBottom: 10 }}>
          {erro}
        </div>
      )}

      {fotos.length === 0 ? (
        <div style={{ color: '#888', fontSize: 13, fontStyle: 'italic' }}>
          Nenhuma foto cadastrada para este produto.
        </div>
      ) : (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
          {fotos.map(f => (
            <div key={f.id} style={{
              width: 160, border: f.padrao ? '2px solid #2563eb' : '1px solid #ccc',
              borderRadius: 8, overflow: 'hidden', background: '#fff',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            }}>
              <div style={{ position: 'relative', height: 140, background: '#f3f4f6',
                display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src={`${BACKEND_URL}${f.arquivo}`} alt="Foto do produto"
                  style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                {f.padrao && (
                  <span style={{ position: 'absolute', top: 4, left: 4, background: '#2563eb',
                    color: '#fff', fontSize: 10, fontWeight: 'bold', padding: '2px 6px',
                    borderRadius: 4 }}>⭐ PADRÃO</span>
                )}
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 6px' }}>
                {!f.padrao ? (
                  <button style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 12, color: '#2563eb' }}
                    title="Marcar como foto padrão" onClick={() => marcarPadrao(f)}>
                    ⭐ Padrão
                  </button>
                ) : <span />}
                <button style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 12, color: '#b91c1c' }}
                  title="Excluir foto" onClick={() => excluir(f)}>
                  ✕ Excluir
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
